goog.provide("shadow.js.shim.module$src$svg$objects$movie_svg$default");
shadow.js.shim.module$src$svg$objects$movie_svg$default = shadow.js.shim.module$src$svg$objects$movie_svg.default;
